import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmpkxhg0ioy/layouts/custom.vue").then(m => m.default || m))
}